import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { ReindexDialog } from "../-components/reindex-dialog"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/settings/reindex",
)({
  component: ReindexFromSettings,
})

function ReindexFromSettings(): React.ReactElement {
  const { tenantId } = Route.useParams()
  const navigate = useNavigate()
  const backToSettings = () =>
    navigate({
      to: "/settings/system/tenants/$tenantId/settings",
      params: { tenantId },
    })

  return (
    <ReindexDialog
      tenantId={tenantId}
      onClose={backToSettings}
      onQueued={backToSettings}
    />
  )
}
